// Lĕyn theme — base interactions

document.addEventListener('DOMContentLoaded', function () {
  // Product gallery thumbnail click — swap main image
  const thumbs = document.querySelectorAll('.pdp-thumb');
  const mainImage = document.getElementById('pdp-main-image');
  if (thumbs.length && mainImage) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        const full = thumb.getAttribute('data-full');
        if (full) mainImage.src = full;
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  }
});
